import React from 'react';
import FitInformationSection from './FitInformationSection';
import GarmentMeasurementSection from '../../GarmentMeasurements/GarmentMeasurementSection';

export default function SizeAndFitAccordionContent(
  {
    textContent,
    fitInformation,
    garmentMeasurements,
    hasFitInformationSectionContent,
    eSpotContent,
    reviewData,
    hasGarmentMeasurements,
    hasFitInfo,
  },
) {
  if (!hasFitInformationSectionContent && !hasGarmentMeasurements) {
    return null;
  }

  return (
    <div className="size-and-fit-accordion-container" data-testid="size-and-fit-accordion-container">
      {hasFitInformationSectionContent && (
        <FitInformationSection
          textContent={textContent}
          fitInformation={fitInformation}
          eSpotContent={eSpotContent}
          reviewData={reviewData}
          hasFitInfo={hasFitInfo}
        />
      )}
      {hasFitInformationSectionContent && hasGarmentMeasurements && (
        <div className="hr size-and-fit-hr" data-testid="size-and-fit-hr" />
      )}
      {hasGarmentMeasurements && (
        <GarmentMeasurementSection
          textContent={textContent}
          garmentMeasurements={garmentMeasurements}
        />
      )}
    </div>
  );
}

SizeAndFitAccordionContent.defaultProps = {
  garmentMeasurements: null,
  fitInformation: null,
};
